import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { stripeHandlersPropTypes } from "components/payments/propTypes";
import RealStripePaymentElement from "components/payments/StripePaymentElement";
import PaymentError from "components/payments/PaymentError";

export default function StripeForm(props) {
  const {
    bodyClass,
    formClass,
    FormButtons,
    onReady,
    onError,
    onSubmission,
    onSuccess,
    returnUrl,
    setupIntentsPath,
    disabled,
    processing,
    errorMessage,
    stripeFormKey,
    StripePaymentElement,
    subscriptionType,
    clientSecret,
    isPaymentIntent
  } = props;

  const [elements, setElements] = useState(null);

  const key = stripeFormKey || "paymentElement";

  const handleStripeAction = () => {
    const { stripe } = window.LitCharts;
    const confirmParams = {
      return_url: returnUrl
    };
    const options = {
      elements,
      redirect: "if_required"
    };

    const action = isPaymentIntent
      ? stripe.confirmPayment
      : stripe.confirmSetup;

    action({
      confirmParams,
      ...options
    }).then((result) => {
      if (result.error) {
        onError(result);
      } else {
        onSuccess(result);
      }
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!onSubmission(e)) {
      return;
    }

    handleStripeAction();
  };

  const buttons = FormButtons ? (
    <FormButtons disabled={disabled} processing={processing} />
  ) : (
    <DefaultFormButtons disabled={disabled} processing={processing} />
  );

  return (
    <form
      className={classnames("stripe-payment-form", formClass)}
      onSubmit={onSubmit}
    >
      <PaymentError errorMessage={errorMessage} testId="stripe-error" />
      <div className={classnames("stripe-payment-form-body", bodyClass)}>
        <StripePaymentElement
          key={key}
          clientSecret={clientSecret}
          setupIntentsPath={setupIntentsPath}
          setElements={setElements}
          onReady={onReady}
          isPaymentIntent={isPaymentIntent}
          subscriptionType={subscriptionType}
        />
      </div>
      {buttons}
    </form>
  );
}

StripeForm.propTypes = {
  StripePaymentElement: PropTypes.elementType,
  isPaymentIntent: PropTypes.bool,
  onSubmission: PropTypes.func,
  returnUrl: PropTypes.string,
  setupIntentsPath: PropTypes.string,
  stripeFormKey: PropTypes.string,
  ...stripeHandlersPropTypes
};

StripeForm.defaultProps = {
  StripePaymentElement: RealStripePaymentElement,
  isPaymentIntent: false,
  onSubmission: () => {
    return true;
  },
  setupIntentsPath: null,
  stripeFormKey: null
};

function DefaultFormButtons({ disabled, processing }) {
  return (
    <button
      className="btn btn-a-plus btn-block"
      type="submit"
      disabled={disabled}
    >
      {processing ? "Processing..." : "Subscribe"}
    </button>
  );
}
